// EMAIL VALIDATION REGEXP
const emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// ===============================


document.addEventListener('DOMContentLoaded', function () {


	const form = document.getElementById('form');
	if (form) {

		const submit = form.querySelector('[type="submit"]');
		submit.addEventListener('click', formSend);

	}
	async function formSend(e) {
		e.preventDefault();


		form.querySelector('.form__result').classList.remove('is-active');

		let error = formValidate(form);
		if (!error) {
			form.classList.remove('has-errors')
			form.classList.add('is-sending');
			let formData = new FormData(form);


			// let appLink = "https://script.google.com/macros/s/AKfycbze3IAeDtrO_fTLCwC5ZrrxD0C1j6B6M9k18sYZE4bmTR8_BO1vHmoW04VOGMIDPx03ew/exec";
			// let appLink = "https://script.google.com/macros/s/AKfycbzURnQp--wJ7HKjqY7fgwBnBkqiwtnhTmMz0O0KTp5XgimzGOBzhXlScngUveWlWHfcLg/exec";
			let appLink = "https://script.google.com/macros/s/AKfycbzKpALtxFp_qLOUEg9G38HEdYTlTNh4C2Ao_xC1xH4BiyZQj-wFPhfd5TuRmXH2iODE/exec";

			let userMessage = `Не удалось отправить сообщение.`;


			$.ajax({

				url: appLink,
				type: "POST",
				data: formData,
				processData: false,
				contentType: false,
				beforeSend: function () {

					if (formData.get('honeypot').length) {
						return false;
					} else {
						formData.delete('honeypot');
					}
				},

			}).done(function (res, textStatus, jqXHR) {

				if (jqXHR.readyState === 4 && jqXHR.status === 200) {

					form.classList.remove('is-sending');
					form.classList.add('is-success');

					userMessage = `Спасибо, ваша заявка успешно отправлена!`;
					addFormResult(form, '', userMessage);

					// Очищаем поля формы
					form.reset();

				} else {

					form.classList.remove('is-sending');
					addFormResult(form, 'Гугл не ответил статусом 200', userMessage);

				}
			}).fail(function (res, textStatus, jqXHR) {

				form.classList.remove('is-sending');
				addFormResult(form, 'Не удалось выполнить запрос по указанному в скрипте пути', userMessage);

			});

		}
		else {
			form.classList.add('has-errors');
			// тут пользователю и так подсвечены нужные поля
		}
	}

	function formValidate(form) {
		let error = false;
		const fieldsRequeired = form.querySelectorAll('[required]');
		if (fieldsRequeired.length > 0) {
			for (const input of fieldsRequeired) {
				if (isInputError(input)) {
					error = true;
				}
			}
		}
		return error;
	}

	function isInputError(input) {
		inputRemoveError(input);
		if (input.getAttribute('type') === 'email') {
			if (input.value === '') {
				inputAddError(input, 'Заполните это поле');
				return true;
			} else if (!validateEmail(input.value)) {
				inputAddError(input, 'Введите корректный e-mail');
				return true;
			}
		} else if (input.getAttribute('type') === 'checkbox' && !input.checked) {
			inputAddError(input, '');
			return true;
		} else if (input.value === '') {
			inputAddError(input, 'Заполните это поле');
			return true;
		} else {
			return false;
		}
	}

	function inputAddError(input, errorMessage) {
		if (errorMessage != '') {
			input.placeholder = errorMessage;
		}
		input.closest('.form__input-holder').classList.add('is-error');
	}

	function inputRemoveError(input) {
		if (input.closest('.form__input-holder').classList.contains('is-error')) {
			input.closest('.form__input-holder').classList.remove('is-error');
			// for (const element of input.closest('.form__input-holder').querySelectorAll('.form__error')) {
			// 	element.remove();
			// }
		}
	}

	function addFormResult(target, message, userMessage) {
		// if (document.querySelector('.form__result')) document.querySelector('.form__result').remove();
		target.querySelector('.form__result').classList.add('is-active');
		target.querySelector('.form__result').innerHTML = userMessage;
		// target.remove();
		// bodyStopScroll();
		// document.getElementById(userMessage).classList.add('m-active');
		console.log(message);
	}


	// check email
	function validateEmail(email) {
		const re = emailRegexp;
		return re.test(email);
	}

	// ==================================













});